export default "__VITE_ASSET__D$CayFKn__"